import { render, staticRenderFns } from "./CenterWeChat.vue?vue&type=template&id=7911bc91&scoped=true&"
import script from "./CenterWeChat.vue?vue&type=script&lang=js&"
export * from "./CenterWeChat.vue?vue&type=script&lang=js&"
import style0 from "./CenterWeChat.vue?vue&type=style&index=0&id=7911bc91&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7911bc91",
  null
  
)

export default component.exports